import { calcAspectRatio } from "./calcAspectRatio";

export const decideIfFullWidthOrFullHeightImg = ({
    imgWidth,
    imgHeight,
    wrapperAspectRatio,
  }) => {
    let wrapperAspectRatioCalc = calcAspectRatio(wrapperAspectRatio);
    let imgRatioCalc = imgWidth / imgHeight;
    //if image is relatively 'narrower' than the wrapper, then it should take full width
    if (wrapperAspectRatioCalc > imgRatioCalc) {
      return "fullWidth";
    }
    //if they are exactly the same, then image can take fullWidth
    else if (imgRatioCalc === wrapperAspectRatioCalc) {
      return "fullWidth";
    }
    //if image is relatively 'wider' than the wrapper, then it should take full height
    else if (imgRatioCalc > wrapperAspectRatioCalc) {
      return "fullHeight";
    }
  };